// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__31-eG","subheader":"ReorderModal_subheader__1YtJF","listWrap":"ReorderModal_listWrap__10HbC"};